import { instance4 } from "App/constants";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import {
  isNull,
} from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { LIST_URL_AKUNTANSI } from "utils/akuntansi";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = LIST_URL_WAREHOUSE.masterBarangLGS.get;
export const urlCreate = LIST_URL_WAREHOUSE.masterBarangLGS.add;
export const urlUpdate = LIST_URL_WAREHOUSE.masterBarangLGS.update;
export const urlDelete = LIST_URL_WAREHOUSE.masterBarangLGS.delete;
export const urlGetById = LIST_URL_WAREHOUSE.masterBarangLGS.getById;
export const urlUpload = LIST_URL_WAREHOUSE.masterBarangLGS.upload;
export const urlDownload = LIST_URL_WAREHOUSE.masterBarangLGS.download;

export const urlGetProdusen = LIST_URL_WAREHOUSE.masterProdusenLGS.get;
export const urlGetSatuan = LIST_URL_WAREHOUSE.masterSatuanLGS.get;
export const urlGetGolonganBarang = LIST_URL_WAREHOUSE.masterGolBarangLGS.get;
export const urlGetGolonganCoa = LIST_URL_AKUNTANSI.coa.getByLevel;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  nama: "",
  produsen_id: "",
  produsen_name: "Pilih Produsen", 
  tglAwal: "",
  tglAkhir: "",
};
export const RESET_STATE_MASTER_BARANG = {
  id:"",
  name: "",

  satuanbeli_id: "",
  satuanbeli_name: "Pilih Satuan Beli",

  satuanjual_id: "",
  satuanjual_name: "Pilih Satuan Pakai",

  qjb: "0",
  kode_produk: "",

  golongan_id: "",
  golongan_name: "Pilih Golongan Barang",

  produsen_id: "",
  produsen_name: "Pilih Produsen",

  golcoa_id: 0,
  golcoa_code: "",
  golcoa_name: "Pilih COA",

  stockmin: 0,
  stockmax: 0,
  // nilaikritis: 0,
  hargabeli: 0,
  hargapokok: 0,
  barcode: "",
  is_active: true,

  // tidak diinput user
  // harga_pokok: 0,
  persediaan: 0,
  qty: "",
  akses: false,
};

export const STYLE_MASTER_BARANG = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const validation = (formData) => {
  if (isNull(formData.stockmin) || formData.stockmin < 0) {
    return {
      state: false,
      message: "Stock min tidak boleh kurang dari 0 atau kosong!",
    };
  }

  if (isNull(formData.stockmax) || formData.stockmax < 0) {
    return {
      state: false,
      message: "Stock max tidak boleh kurang dari 0 atau kosong!",
    };
  }

  // if (isNull(formData.nilaikritis) || formData.nilaikritis < 0) {
  //   return {
  //     state: false,
  //     message: "Nilai kritis tidak boleh kurang dari 0 atau kosong!",
  //   };
  // }

  if (isNull(formData.name)) {
    return {
      state: false,
      message: "Nama Barang tidak boleh kosong!",
    };
  }

  if (isNull(formData.satuanbeli_id)) {
    return {
      state: false,
      message: "Harap pilih satuan beli !",
    };
  }

  if (isNull(formData.satuanjual_id)) {
    return {
      state: false,
      message: "Harap pilih satuan jual !",
    };
  }

  if (isNull(formData.golongan_id)) {
    return {
      state: false,
      message: "Harap pilih golongan barang !",
    };
  }

  if (isNull(formData.produsen_id)) {
    return {
      state: false,
      message: "Harap pilih produsen barang !",
    };
  }

  return {
    state: true,
  };
};

export const getByFilterBarang = async (formFilter, pages, limit, withoutDate = false) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      name: formFilter.nama,
      produsen_id: formFilter.produsen_id,
      tglAwal: withoutDate ? "" : isNull(formFilter.tglAwal) ? "" : startOfDay(formFilter.tglAwal),
      tglAkhir: withoutDate ? "" : isNull(formFilter.tglAkhir) ? "" :  lastOfDay(formFilter.tglAkhir),
      offset: pages - 1,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getById = async (id) => {
  try {
    const res = await instance4.get(`${urlGetById}/${id}`);
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        akses: res.data.akses,
      };
    } else {
      return {
        state: false,
        message: "Sepertinya ada yang tidak beres dengan data ini",
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteMasterBarangById = async (id) => {
  try {
    await instance4.post(urlDelete, {
      id,
    });
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "persediaan",
    disablePadding: false,
    label: "QTY",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "hargaPokok",
    disablePadding: false,
    label: "HARGA POKOK",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "hargaBeli",
    disablePadding: false,
    label: "HARGA BELI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "satuanBeli",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "satuanPakai",
    disablePadding: false,
    label: "SATUAN PAKAI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "namaProdusen",
    disablePadding: false,
    label: "PRODUSEN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsSuccess = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "center",
    sort: true,
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    sort: true,
    minWidth: "200px",
  },
];
